<template>
<div class="toggle-container">
	<div class="toggle">
		<input type="checkbox" class="toggle-checkbox"  v-model="value">
		<label v-on:click="change" class="toggle-label">
			<span class="toggle-inner"></span>
			<span class="toggle-switch"></span>
		</label>
	</div>
</div>
</template>

<script>
const props = {
	value: {
		type: Boolean,
		default: false
	},
	confirm: {
		type: Boolean,
		default: false
	},
	labelOn: {
		type: String,
		default: 'on'
	},
	labelOff: {
		type: String,
		default: 'off'
	}
}

export default{
	props: props,
	methods: {
		change () {
			this.$emit('change', this.value)
		}
	}
}

</script>
<style>
.toggle-container{
	display: inline-block;
	vertical-align: top;
}
.toggle {
    position: relative; width: 75px;
    margin: 0 10px;
    -webkit-user-select:none; -moz-user-select:none; -ms-user-select: none;
}
.toggle-checkbox {
    display: none;
}
.toggle-label {
    display: block; overflow: hidden; cursor: pointer;
    border: 2px solid #999999; border-radius: 5px;
}
.toggle-inner {
    display: block; width: 200%; margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
}
.toggle-inner:before, .toggle-inner:after {
    display: block; float: left; width: 50%; height: 25px; padding: 0; line-height: 25px;
    font-size: 14px; color: white; font-family: Trebuchet, Arial, sans-serif; font-weight: bold;
    box-sizing: border-box;
}
.toggle-inner:before {
    content: "ON";
    padding-left: 10px;
    background-color: #9CCC65; color: #FFFFFF;
}
.toggle-inner:after {
    content: "OFF";
    padding-right: 10px;
    background-color: #EEEEEE; color: #999999;
    text-align: right;
}
.toggle-switch {
    display: block; width: 14px; margin: 5.5px;
    background: #FFFFFF;
    position: absolute; top: 0; bottom: 0;
    right: 46px;
    border: 2px solid #999999; border-radius: 5px;
    transition: all 0.3s ease-in 0s;
}
.toggle-checkbox:checked + .toggle-label .toggle-inner {
    margin-left: 0;
}
.toggle-checkbox:checked + .toggle-label .toggle-switch {
    right: 0px;
}
</style>


// WEBPACK FOOTER //
// Toggle.vue?09c98c9d